import { BlockPrimitive, DataChangeStruct, Layer, Primitive, PythaEngineControl, PythaEventName, PythaEventSetting, PythaEventZoomAll } from 'pytha2';
import './index.less';
import { useEffect, useState, useRef, useContext } from 'react';
import { findBlocksInProject, findLayersInProjectUuid, findPrimitivesInProject } from '@/declare/api/primitive';
import { EngineContext } from '@/App';
import fontPath from '@/store/fonts/GB2312.ttf';
import opentype from 'opentype.js';
import { Transfer2DisplayScale } from '@/utils/unit';
import localStore from '@/store/local-store';
import { addMonitorObjectPrimitive, deleteMonitorObjectPrimitive, findMonitorObjectPrimitiveByProjectId, queryMobjects, queryMobjectsByWarningLevel, updateMonitorObjectPrimitive } from '@/declare/api/monix';
import { mobject } from '@/declare/interface/mobject';
import { MObjectPrimitive, MonitorObjectPrimitive } from '@/declare/interface/primitive';
import { Button, Modal, message } from 'antd';
import { MobjectBaseType } from '@/utils/type';
import { useParams } from 'react-router-dom';
import { Point } from 'tnbase';
import MObjectLabelMain from './mobject-page';
import { getGroups } from '@/declare/api/group';
import { ReactComponent as PanSvg } from './icons/pan.svg';
import { ReactComponent as RotateSvg } from './icons/3do.svg';
import { ReactComponent as ZaSvg } from './icons/za.svg';
import { ReactComponent as NavSvg } from './icons/nav.svg';
interface IProps {

}
/**
 * 最大单次加载图元量
 */
export const maxLoadPrimitiveNum = 1000;

export default function ScreenGraphic(props: IProps) {

    const { monixProjectId, bimProjectId, bimModelUuid } = useParams()
    /**
     * 记录分批次加载图元的批数，用于判断是否结束加载中的状态
     */
    const countRef = useRef(0);
    /**
     * 引擎上下文，用于管理全局的引擎实例。
     */
    const engineContext = useContext(EngineContext);
    /**
     * 使用状态来存储从后端获取的 mobjects 列表（并补充了图元关联表的相关字段）
     */
    const [mobjects, setMobjects] = useState<MObjectPrimitive[]>([]);
    /**
     * 控制是否显示绑定弹窗
     */
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    /**
     * 存储关联弹窗当前选中的 mobject 的 ID
     */
    const [selectedMobjectId, setSelectedMobjectId] = useState<number | null>(null);
    /**
     * 选中的图元uuid
     */
    const [activeEntityUuid, setActiveEntityUuid] = useState<string>("")

    useEffect(() => {
        const root = document.getElementById("viewport"); // 获取视图容器 DOM 元素
        if (!root) return;
        const engine = new PythaEngineControl(); // 创建引擎实例
        engine.switchOn(root); // 启动引擎并绑定到视图容器

        // 设置背景透明
        engine.storage.viewportStore.renderer.domElement.style.background = "#00000000"
        // 设置鼠标默认可见
        engine.storage.viewportStore.renderer.domElement.style.cursor = "default"
        // 设置世界坐标系隐藏
        engine.storage.coordinateStore.showUcs = false
        // 设置光标隐藏
        engine.storage.cursorStore.cursorShow = false
        // 设置屏蔽框选
        engine.storage.selectStore.rangeSelectEnabled = false
        // 设置开启单选
        engine.storage.selectStore.pickOnly = true
        // 设置夹点隐藏
        engine.storage.clampStore.clampDisable = true
        // 保存引擎到全局上下文
        engineContext.setEngine(engine);


        // 初始化图元数据
        registEngineData(engine);

        const unsubscribe = engine.eventMediator.noticeHandler?.onNotice?.subscribe((sender, event) => {
            if (event.cmd === PythaEventName.DATA_CHANGE) {

                let data = event?.data as DataChangeStruct;
                if (!data) return;

                // 监听选择变更
                if (data.selectChanged) {
                    if (engine.storage?.selectStore.selectPrimitives.length > 0) {
                        let pri = engine.storage.selectStore.selectPrimitives[0]
                        setActiveEntityUuid(pri.uuid)
                    } else {
                        setActiveEntityUuid(null)
                        // setDisplayLayerUuid(currentLayerUuid);
                    }
                }
            }
        });
        return () => {
            unsubscribe?.();
            if (engine) {
                engine.switchOff();
                root.replaceChildren();
                engineContext.setEngine(null);
            }
        };
    }, [])

    const initMonixData = async (engine: PythaEngineControl, monixProjectId: number) => {
        return new Promise((r, j) => {
            Promise.all([
                queryMobjectsByWarningLevel({ project_id: monixProjectId }),
                findMonitorObjectPrimitiveByProjectId(monixProjectId)
            ]).then(([mobjectsRes, primitivesRes]) => {
                if (mobjectsRes.status === 200 && primitivesRes.status === 200) {
                    const mobjectList: mobject[] = mobjectsRes.data || [];
                    const monitorPrimitives: MonitorObjectPrimitive[] = primitivesRes.data || [];
                    let primitiveMap = engine.storage.primitiveStore.primitiveDict
                    // 遍历 mobjectList，找到与每个 mobject 匹配的 primitive
                    const updatedMobjects: MObjectPrimitive[] = []
                    for (let i = 0; i < mobjectList.length; i++) {
                        let mobject = mobjectList[i]
                        const matchingPrimitive = monitorPrimitives.find(
                            (primitive) => primitive.monitor_object_id === mobject.id
                        );
                        if (matchingPrimitive) {
                            let newObj: MObjectPrimitive = { ...mobject, primitive_uuid: matchingPrimitive.primitive_uuid }
                            // 获取图元
                            let pri = primitiveMap[matchingPrimitive.primitive_uuid]
                            if (pri) {
                                newObj.primitive_center = calcPrimitiveCenter(pri, engine)

                            }
                            updatedMobjects.push(newObj)
                        } else {
                            updatedMobjects.push(mobject)
                        }
                    }

                    setMobjects(updatedMobjects); // 更新 mobjects 状态
                } else {
                    message.error("获取列表或关联数据失败");
                }
                r(true)
            }).catch(e => {
                j(e)
            })
        })
    }

    const registEngineData = async (engine: PythaEngineControl) => {
        try {
            // 注册加载文字
            if (engineContext.fontSource) {
                engine.registFont(engineContext.fontSource);
            } else {
                const font = await loadFont(fontPath);
                engineContext.setFontSource(font)
                engine.registFont(font);
            }
            // 设置引擎单位换算
            let unit = engineContext.unit;
            let unitRatio = Transfer2DisplayScale(unit);
            engine.registUnitRatio(1 / unitRatio);
            // 注册加载块
            const blocks = await loadBlocks(bimProjectId) || [];
            engine.registBlocks(blocks);
            // 注册加载组
            const groups = await loadGroups(bimProjectId) || [];
            engine.registGroups(groups);

            // const storeyRes = await getStoreysByProject(projectUuid);
            // const storeys = storeyRes.data || [];

            let layerList: Layer[] = await getLayerList(bimProjectId)
            // 筛选出轴网图层
            let sortLayerUuidList: string[] = []
            for (let i = 0; i < layerList.length; i++) {
                if (layerList[i].name.includes("轴")) {
                    sortLayerUuidList.push(layerList[i].uuid)
                }
            }  
            await initModels(engine, sortLayerUuidList);
            // 初始化监测数据
            await initMonixData(engine, Number(monixProjectId))
            // 图元全显
            let zaEvent = new PythaEventZoomAll();
            zaEvent.data = {};
            engine.eventMediator?.emitEvent(zaEvent);

        } catch (error) {
            console.log(error)
        }
    }

    /**
     * 获取图层列表
     * @param projectUuid 
     * @returns 
     */
    const getLayerList = (projectUuid: string): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            findLayersInProjectUuid(projectUuid).then(res => {
                let layerList: Layer[] = res.data
                resolve(layerList)
            }).catch(e => {
                resolve([])
            })
        })
    }

    /**
     * 加载字体库
     * @param fontPath 
     * @returns 
     */
    const loadFont = (fontPath: string): Promise<opentype.Font> => {
        return new Promise((resolve, reject) => {
            opentype.load(fontPath, (err, font) => {
                if (err) {
                    reject(err); // 如果加载失败，调用 reject 并传入错误信息
                } else {
                    resolve(font); // 如果加载成功，调用 resolve 并传入字体对象
                }
            });
        });
    }

    /**
     * 加载块模板
     * @param projectUuid 
     * @returns 
     */
    const loadBlocks = (projectUuid: string): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            findBlocksInProject(projectUuid).then(res => {
                let jsonList = res.data || [];
                let blocks = [];
                for (let json of jsonList) {
                    let data = json.properties;
                    if (data != null) {
                        blocks.push(data);
                    }
                }
                resolve(blocks);
            }).catch(err => {
                reject(err);
            })
        })
    }

    /**
     * 初始化图元
     * @param engine 
     * @returns 
     */
    const initModels = async (engine: PythaEngineControl, sortLayerUuidList: string[] = []): Promise<any> => {
        return new Promise((resolve, reject) => {
            findPrimitivesInProject(bimProjectId, { modelUuid: bimModelUuid }).then(res => {
                let jsonList: any[] = res.data || [];
                let jsonPrimitives = [];
                countRef.current = 0;

                for (let i = 0; i < jsonList.length; i++) {
                    let json = jsonList[i].properties;
                    if (json.type == "AxisNet") {
                        continue;
                    }
                    if (sortLayerUuidList.includes(json.layerUuid)) {
                        continue;
                    }
                    jsonPrimitives.push(json);
                    if (jsonPrimitives.length >= maxLoadPrimitiveNum) {
                        engine.resolvePrimitives(jsonPrimitives);
                        countRef.current += 1;
                        jsonPrimitives = [];
                    }
                }
                // 最后一轮如果不到上限，需要再手动做一次加载
                if (jsonPrimitives.length > 0) {
                    engine.resolvePrimitives(jsonPrimitives);
                    countRef.current += 1;
                }
                resolve(true);
            })
        })
    }

    /**
     * 加载组
     * @param projectUuid 
     * @returns 
     */
    const loadGroups = (projectUuid: string): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            getGroups(projectUuid).then(res => {
                let groups = res.data || [];
                resolve(groups);
            }).catch(err => {
                reject(err);
            })
        })
    }


    /**
     * 弹窗点击“取消”时的函数
     */
    const handleCancel = () => {
        setSelectedMobjectId(null);
        setIsPopupVisible(false);
    };

    /**
     * 弹窗点击确认的函数
     * @returns 
     */
    const handleConfirmBinding = () => {
        // 判断当前图元是否已经绑定过
        const matchedObject = mobjects.find(mobject => mobject.primitive_uuid === activeEntityUuid);
        //删除：判断条件之前绑定过，当前没有选择绑定对象
        if (!selectedMobjectId && matchedObject) {
            // 仅取消绑定
            handleDelete();
            return;
        }
        //更新：判断条件已经绑定对象，但是选择绑定对象与之前不同
        if (matchedObject && selectedMobjectId) {
            // 进行更新绑定
            handleUpdate();
            //新增：判定条件之前没有绑定但是现在选择了绑定对象
        } else if (selectedMobjectId) {
            // 新增绑定
            handleAdd();
        } else {
            message.warning("请选择一个监测对象！");
        }
    };

    /**
     * 删除绑定的监测对象
     */
    const handleDelete = () => {
        deleteMonitorObjectPrimitive(activeEntityUuid)
            .then(res => {
                if (res.status === 200) {
                    message.success("删除成功！");
                    setIsPopupVisible(false);
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.primitive_uuid === activeEntityUuid
                                ? { ...mobject, primitive_uuid: null, primitive_center: null }
                                : mobject
                        )
                    );
                    setSelectedMobjectId(null); // 清空选中项
                } else {
                    message.error("删除失败，请重试！");
                }
            })
            .catch(error => {
                console.error("删除失败：", error);
                message.error("删除失败，请重试！");
            });
    };

    /**
     * 添加监测对象的绑定
     */
    const handleAdd = () => {
        addMonitorObjectPrimitive(Number(monixProjectId), selectedMobjectId, activeEntityUuid)
            .then(res => {
                if (res.status === 200) {
                    message.success("绑定成功！");
                    setIsPopupVisible(false); // 关闭弹窗
                    setSelectedMobjectId(null); // 清空选中项
                    let pri = engineContext.engine.storage.primitiveStore.primitiveDict[activeEntityUuid]
                    let center: Point = calcPrimitiveCenter(pri, engineContext.engine)
                    // 更新 mobjects 中对应项的 primitive_uuid
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.id === selectedMobjectId
                                ? { ...mobject, primitive_uuid: activeEntityUuid, primitive_center: center }
                                : mobject
                        )
                    );
                } else {
                    message.error("绑定失败，请重试！");
                }
            })
            .catch(error => {
                console.error("绑定失败：", error);
                message.error("绑定失败，请重试！");
            });
    };

    /**
     * 更新监测对象的绑定
     */
    const handleUpdate = () => {
        const data = {
            project_id: Number(monixProjectId),
            primitive_uuid: activeEntityUuid,
            monitor_object_id: selectedMobjectId
        };

        updateMonitorObjectPrimitive(activeEntityUuid, data)
            .then(res => {
                if (res.status === 200) {
                    message.success("更新成功！");
                    setIsPopupVisible(false); // 关闭弹窗
                    setSelectedMobjectId(null); // 清空选中项
                    let pri = engineContext.engine.storage.primitiveStore.primitiveDict[activeEntityUuid]
                    let center: Point = calcPrimitiveCenter(pri, engineContext.engine)
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.primitive_uuid === activeEntityUuid
                                ? { ...mobject, primitive_uuid: null, primitive_center: null }
                                : mobject
                        ).map(mobject =>
                            mobject.id === selectedMobjectId
                                ? { ...mobject, primitive_uuid: activeEntityUuid, primitive_center: center }
                                : mobject
                        )
                    );
                    setSelectedMobjectId(null);
                } else {
                    message.error("更新失败，请重试！");
                }
            })
            .catch(error => {
                console.error("更新失败：", error);
                message.error("更新失败，请重试！");
            });
    };

    /**
     * 绑定弹窗的选择栏
     * @param id 
     */
    const handleRowSelect = (id: number) => {
        if (selectedMobjectId === id) {
            // 如果再次点击同一个 ID，清空选中项
            setSelectedMobjectId(null);
        } else {
            // 否则设置为新的选中项
            setSelectedMobjectId(id);
        }
    };

    /**
     * 判断是否可以选中，已绑定的且不是当前 activeEntityUuid 的项目不可选
     * @param mobject 
     * @returns 
     */
    const isSelectable = (mobject) => {
        return !mobject.primitive_uuid || mobject.primitive_uuid === activeEntityUuid;
    };

    /**
     * 点击绑定监测对象按钮
     */
    const onClickBindMObject = () => {
        if (activeEntityUuid) {
            const matchedObject = mobjects.find(mobject => mobject.primitive_uuid === activeEntityUuid);
            if (matchedObject) {
                // 设置 selectedMobjectId 为与 activeEntityUuid 对应的 mobject id
                setSelectedMobjectId(matchedObject.id);
            } else {
                // 如果没有匹配项，则清空 selectedMobjectId
                setSelectedMobjectId(null);
            }
            setIsPopupVisible(true)
        } else {
            message.warning("请先选中绑定图元")
        }
    }

    /**
     * 计算图元中心点
     * @param pri 
     * @param engine 
     */
    const calcPrimitiveCenter = (pri: Primitive, engine: PythaEngineControl) => {
        let center: Point = new Point()
        if (pri.type == "Block") {
            let bt = engine.storage.blockStore.blockTemplateDict[(pri as BlockPrimitive).blockTemplateUuid];
            let boundingBox = BlockPrimitive.calBlockBoundingBox(bt, pri.worldModelMatrix, engine.storage.blockStore.blockTemplateDict);
            boundingBox.getCenter(center)
        } else {
            center.copy(pri.getCenter())
        }
        return center
    }

    /**
     * 激活事件图
     * @param cmd 
     */
    const activeGraph = (cmd: string) => {
        if (engineContext?.engine) {
            engineContext.emitCommand(cmd);
        }
    }

    return (
        <div className='screen-graphic-container'>
            <div className='viewport-wrap'>
                <div className='viewport' id='viewport'>
                    <MObjectLabelMain
                        mobjectPrimitiveList={mobjects}
                    />
                </div>
                <div className='ope-bar'>
                    <div className='ope-block' onClick={() => activeGraph('PAN')}><PanSvg /></div>
                    <div className='ope-block' onClick={() => activeGraph('3DO')}><RotateSvg /></div>
                    <div className='ope-block' onClick={() => {
                        if (!engineContext?.engine) return;
                        const pythaEvent = new PythaEventZoomAll();
                        pythaEvent.data = {};
                        engineContext?.engine?.eventMediator?.emitEvent(pythaEvent);
                    }}><ZaSvg /></div>
                    <div className='ope-block' onClick={() => onClickBindMObject()}><NavSvg /></div>
                </div>
            </div>

            <Modal
                title="绑定监测对象"
                open={isPopupVisible}
                onCancel={() => setIsPopupVisible(false)}
                footer={[
                    <Button key="close" onClick={handleCancel}>
                        取消
                    </Button>,
                    <Button key="confirm" type="primary" onClick={handleConfirmBinding} disabled={!selectedMobjectId && !mobjects.find(m => m.primitive_uuid === activeEntityUuid)}>
                        确定
                    </Button>
                ]}
            >
                <div className="table-container">
                    <div className="table-header">
                        <div className="radio-placeholder"></div>
                        <span>监测对象名称</span>
                        <span>监测类型</span>
                    </div>
                    <div className="table-body">
                        {mobjects.map((mobject) => {
                            const isDisabled = !isSelectable(mobject); // 判断该项是否不可选
                            return (
                                <div
                                    key={mobject.id}
                                    className={`table-row ${selectedMobjectId === mobject.id ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                    onClick={() => !isDisabled && handleRowSelect(mobject.id)} // 只有可选项才能点击
                                >
                                    <input
                                        type="radio"
                                        name="tableRow"
                                        checked={selectedMobjectId === mobject.id}
                                        onChange={() => handleRowSelect(mobject.id)}
                                        disabled={isDisabled} // 禁用已绑定的且不是当前 activeEntityUuid 的项目
                                    />
                                    <span>{mobject.name}</span>
                                    <span>{MobjectBaseType[mobject.type]?.alias || '未知类型'}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Modal>
        </div>
    )
}